import { emailAddress, password } from '../common/forms/validationSchemas';
import { FormBase } from 'ascendon-web-toolkit/validations';

export class LoginInfo extends FormBase {
  constructor({ locale, customFieldProps } = {}) {
    super({ locale, customFieldProps });
    this.defaultFields = [
      {
        inputName: 'emailAddress',
        inputDisplayName: 'Email',
        initialValue: '',
        validation: emailAddress,
      },
      {
        inputName: 'password',
        inputDisplayName: 'Password',
        initialValue: '',
        validation: password,
      },
    ];
  }
}
